import type React from "react";
import { Link } from "react-router-dom";
import DesktopMenu from "@/components/Header/Header/DesktopMenu";
import MobileMenu from "@/components/Header/Header/MobileMenu";
import {
  BUSINESS_NAME,
  BUSINESS_TAGLINE,
  EMAIL,
} from "@/businessInfo/business";

const Header: React.FC = () => {
  return (
    <header className="sticky top-0 z-50 border-b shadow-sm border-neutral-200 bg-white/90 text-neutral-900 backdrop-blur-sm">
      <div className="container flex items-center h-20 gap-4">
        <Link to="/" className="flex items-center gap-3 text-left">
          <img
            src="/images/logo/logo.jpg"
            alt={`${BUSINESS_NAME} logo`}
            className="flex-shrink-0 object-contain w-10 h-10 sm:h-12 sm:w-12"
            width={48}
            height={48}
            loading="eager"
            decoding="async"
          />
          <span className="flex flex-col min-w-0">
            <span className="text-base font-semibold truncate text-neutral-900 sm:text-lg">
              {BUSINESS_NAME}
            </span>
            {BUSINESS_TAGLINE ? (
              <span className="text-xs truncate text-neutral-500 sm:text-sm">
                {BUSINESS_TAGLINE}
              </span>
            ) : null}
          </span>
        </Link>

        <div className="flex items-center gap-3 ml-auto">
          <DesktopMenu />
          <a
            href={`mailto:${EMAIL}`}
            className="items-center hidden px-4 py-2 text-sm font-semibold text-white transition rounded-full shadow-sm bg-primary-700 hover:bg-primary-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300/70 focus-visible:ring-offset-1 focus-visible:ring-offset-white sm:inline-flex"
          >
            Contact
          </a>
          <MobileMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
